import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Instagram, 
  Linkedin,
  Mail, 
  Phone, 
  MapPin,
  ArrowRight
} from 'lucide-react';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative bg-gradient-to-br from-primary-900 via-primary-900 to-primary-800 text-white overflow-hidden">
      {/* Arka plan için dekoratif, silik bir efekt */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-secondary-500/20 to-transparent"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        {/* Ana Grid Yapısı: 12'li sistem güncellendi (4+2+3+3) */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-start">
          
          {/* 1. SOL BLOK: Şirket Bilgisi (4 birim) */}
          <div className="lg:col-span-4 space-y-8">
            <div>
              <h3 className="text-3xl font-display font-bold tracking-tight">
                LOTUS <span className="text-secondary-300">SPORT</span>
              </h3>
              <p className="mt-4 text-lg text-primary-100 leading-relaxed max-w-sm">
                Yapay zeka tabanlı dijital sağlık ve egzersiz çözümleri sunan, 
                geleceği şekillendiren yenilikçi teknoloji girişimi.
              </p>
            </div>

            {/* Sosyal Medya İkonları */}
            <div className="flex space-x-3">
              <SocialButton 
                href="https://www.instagram.com/exer_eyes/" 
                label="Instagram Exer Eyes"
                icon={<Instagram size={20} />}
                hoverColor="hover:from-pink-500 hover:to-rose-500"
              />
              <SocialButton 
                href="https://www.instagram.com/lotussporttech/" 
                label="Instagram LotusSportTech"
                icon={<Instagram size={20} />}
                hoverColor="hover:from-fuchsia-500 hover:to-purple-500"
              />
              <SocialButton 
                href="https://www.linkedin.com/company/lotussporttech/" 
                label="LinkedIn"
                icon={<Linkedin size={20} />}
                hoverColor="hover:from-blue-600 hover:to-cyan-500"
              />
            </div>
          </div>

          {/* 2. YENİ BLOK: Kurumsal Linkler (2 birim) */}
          <div className="lg:col-span-2">
            <h4 className="text-lg font-semibold text-white mb-6 flex items-center">
              <span className="w-8 h-0.5 bg-secondary-400 mr-3"></span>
              Kurumsal
            </h4>
            <ul className="space-y-4">
              <li><FooterLink to="/about">Hakkımızda</FooterLink></li>
              <li><FooterLink to="/projects">Projelerimiz</FooterLink></li>
              {/* İSTENEN SSS LİNKİ BURAYA EKLENDİ */}
              <li><FooterLink to="/faq">Sık Sorulan Sorular</FooterLink></li>
              <li><FooterLink to="/contact">İletişim</FooterLink></li>
            </ul>
          </div>

          {/* 3. ORTA BLOK: İletişim (3 birim) */}
          <div className="lg:col-span-3">
            <h4 className="text-lg font-semibold text-white mb-6 flex items-center">
              <span className="w-8 h-0.5 bg-secondary-400 mr-3"></span>
              İletişim
            </h4>
            <ul className="space-y-6">
              <li className="flex items-start group">
                <div className="mt-1 w-10 h-10 rounded-lg bg-primary-800 flex items-center justify-center flex-shrink-0 group-hover:bg-secondary-500/20 transition-colors duration-300">
                  <MapPin className="h-5 w-5 text-secondary-300" />
                </div>
                <div className="ml-4">
                  <span className="block text-sm text-primary-300 font-medium mb-1">Adres</span>
                  <span className="text-primary-100 leading-snug text-sm">
                    Entertech İstanbul Teknokent
                  </span>
                </div>
              </li>
              
              <ContactItem 
                icon={<Phone className="h-5 w-5 text-secondary-300" />}
                title="Telefon"
                content={
                  <div className="flex flex-col space-y-1">
                    <a href="tel:+905326711570" className="hover:text-white transition-colors flex items-center text-sm">
                      <span className="text-secondary-300 font-medium w-7 inline-block text-xs uppercase tracking-wider">TR:</span> 
                      <span>+90 (532) 671 1570</span>
                    </a>
                    <a href="tel:+31628864484" className="hover:text-white transition-colors flex items-center text-sm">
                      <span className="text-secondary-300 font-medium w-7 inline-block text-xs uppercase tracking-wider">NL:</span> 
                      <span>+31 6 2886 4484</span>
                    </a>
                  </div>
                }
              />

              <ContactItem 
                icon={<Mail className="h-5 w-5 text-secondary-300" />}
                title="E-Posta"
                content={
                  <a href="mailto:info@lotussport.net" className="hover:text-white transition-colors text-sm">
                    info@lotussport.net
                  </a>
                }
              />
            </ul>
          </div>

          {/* 4. SAĞ BLOK: Bülten (3 birim) */}
          <div className="lg:col-span-3">
            <h4 className="text-lg font-semibold text-white mb-6 flex items-center">
              <span className="w-8 h-0.5 bg-secondary-400 mr-3"></span>
              Bülten
            </h4>
            <p className="text-primary-100 mb-6 text-sm leading-relaxed">
              Teknoloji ve sağlık dünyasındaki en son gelişmelerden haberdar olmak için abone olun.
            </p>
            <form onSubmit={(e) => e.preventDefault()} className="relative">
              <div className="relative group">
                <input
                  type="email"
                  required
                  placeholder="E-posta adresiniz"
                  className="w-full pl-4 pr-12 py-4 bg-primary-800/50 border border-primary-700 rounded-xl text-white placeholder-primary-400 focus:outline-none focus:ring-2 focus:ring-secondary-400/50 focus:border-secondary-400 transition-all duration-300"
                />
                <button
                  type="submit"
                  aria-label="Abone Ol"
                  className="absolute right-2 top-2 bottom-2 aspect-square bg-secondary-500 hover:bg-secondary-400 text-white rounded-lg flex items-center justify-center transition-colors shadow-lg shadow-secondary-500/20"
                >
                  <ArrowRight size={18} />
                </button>
              </div>
              <p className="mt-3 text-xs text-primary-400">
                *Kişisel verileriniz KVKK kapsamında korunmaktadır.
              </p>
            </form>
          </div>
        </div>

        {/* ALT BAR: Çizgi ve Linkler */}
        <div className="border-t border-primary-700/50 mt-16 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <p className="text-primary-300 text-sm text-center md:text-left">
              © {year} Lotus Sport Teknoloji A.Ş. Tüm hakları saklıdır.
            </p>

            <div className="flex flex-wrap justify-center gap-x-8 gap-y-2 text-sm font-medium">
              <FooterLink to="/privacy">Gizlilik Politikası</FooterLink>
              <FooterLink to="/kvkk">KVKK Aydınlatma Metni</FooterLink>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

// Yardımcı Bileşenler

const SocialButton = ({ href, label, icon, hoverColor }: { href: string, label: string, icon: React.ReactNode, hoverColor: string }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={label}
    className={`group flex items-center justify-center w-12 h-12 rounded-xl bg-primary-800 border border-primary-700/50 text-primary-300 transition-all duration-300 hover:text-white hover:shadow-lg hover:-translate-y-1 ${hoverColor}`}
  >
    {icon}
  </a>
);

const ContactItem = ({ icon, title, content }: { icon: React.ReactNode, title: string, content: React.ReactNode }) => (
  <li className="flex items-start group">
    <div className="w-10 h-10 rounded-lg bg-primary-800 flex items-center justify-center flex-shrink-0 group-hover:bg-secondary-500/20 transition-colors duration-300 mt-0.5">
      {icon}
    </div>
    <div className="ml-4">
      <span className="block text-sm text-primary-300 font-medium mb-0.5">{title}</span>
      <span className="text-primary-100 group-hover:text-white transition-colors block">
        {content}
      </span>
    </div>
  </li>
);

const FooterLink = ({ to, children }: { to: string, children: React.ReactNode }) => (
  <Link 
    to={to} 
    className="text-primary-300 hover:text-secondary-300 transition-colors duration-200 relative after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-px after:bg-secondary-300 after:transition-all hover:after:w-full inline-block"
  >
    {children}
  </Link>
);

export default Footer;